// Leap-inclusive day count per 1-indexed month: February is 29 so a yearly
// schedule can still target Feb 29 (it then only fires in leap years).
const DAYS_PER_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export const getMonthDayNumbers = (month: number): number[] => {
  const count = DAYS_PER_MONTH[month - 1] ?? 31;
  return Array.from({ length: count }, (_, index) => index + 1);
};
